<template>
  <div id="app">
    <router-view :key="key()"></router-view>
    <!-- <router-view></router-view> -->
    <div v-if="maintain == 1" class="app-notice-bg">
        <div class="app-notice">
          <h3>维护公告</h3>
          <div class="notice-title">尊敬的用户：</div>
          <p>为了保证服务器的稳定和服务质量，本站将进行系统维护升级。对于维护期间给您带来的不便，敬请见谅，感谢所有用户的支持和配合。</p>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      maintain:0
    }
  },
  created(){
    this.getSetting()
  },
  methods:{
    key(){
      return Math.random();
    },
    getSetting(){
      let that = this
      this.axios.get('https://uz.hanlandglobal.com:4433/api/setting').then(function(res) {
        that.maintain = res.data.data.is_maintain;  
      }).catch(function() {
      });
    }
  }

}
</script>
<style lang="scss">
  @media only screen and (min-width: 1920px){
      html{
        font-size: 20px;
      }
  }
 @media only screen and (max-width: 1920px) and (min-width: 1680px){
    html{
      font-size: 20px;
    }
  }
  @media only screen and (max-width: 1680px) and (min-width: 1440px){
    html{
      font-size: 18px;
    }
  }
   @media only screen and (max-width: 1440px) and (min-width: 1366px){
    html{
      font-size: 16px;
    }
  }
  @media only screen and (max-width: 1366px) and (min-width: 1280px){
    html{
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 1280px) and (min-width: 1024px){
    html{
      font-size: 12px;
    }
  }
  @media only screen and (max-width: 1024px){
    html{
      font-size: 10px;
    }
  }
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: "Microsoft YaHei", "WenQuanYi Micro Hei","MicrosoftYaHei-Bold","MicrosoftYaHei","DINAlternate-Bold";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.app-notice-bg{
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba($color: #000000, $alpha: 0.6);
  z-index: 9999999999;
}
.app-notice{
  width: 20rem;
  padding:1rem;
  min-height: 24rem;
  background: #fff;
  h3{
    text-align: center;
    margin-bottom: 1rem;
  }
  .notice-title{
    line-height: 3rem;
  }
  p{
    line-height: 1.8rem;
    text-indent: 2em;
  }
}
@media only screen and (max-width: 1024px){
  .app-notice{
    width: 90%;
    min-height: auto;
  }
}

.el-pagination.is-background .el-pager li{
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #3a4a5b;
  color: #FFF;
}
.el-pagination.is-background .el-pager li.active {
  color: #fff;
  cursor: default;
}
.el-pagination.is-background .el-pager li:hover {
  color: #3a4a5b;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #3a4a5b;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #3a4a5b;
  color: #FFF;
}
.el-pagination button, .el-pagination span{
    width: 3rem;
    height: 2rem;
}
</style>